/* eslint-disable react-hooks/exhaustive-deps */
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Grid } from '@mui/material'
import { PRIMARY_PINK, PRIMARY_YELLOW, PRIMARY_GREEN } from 'utils/customizedTheme'
import Attendance from '../dashboard/Attendance'
import Grades from '../dashboard/Grades'
import { useGET_subjectsQuery } from 'redux/api/subjectsApi'
import PlopStats from '../dashboard/PlopStats'
import { MAX_PER_PAGE } from 'utils/constants'


interface IProps {
  student_id: number
  tabText?: string
  tabKey?: string
}

const StudentReports: FC<IProps> = ({student_id}) => {

  const { data: subjects } = useGET_subjectsQuery({ page: 1, page_size: MAX_PER_PAGE })

  return (
    <Grid container rowSpacing={3} columnSpacing={3}>
      <Grid item xs={12} md={6} lg={6} xl={6}>
        <Attendance />
      </Grid>
      <Grid item xs={12} md={6} lg={6} xl={6}>
        <PlopStats student={student_id} />
      </Grid>
      {subjects && subjects.results.map(s =>
      <Grid item xs={12} md={6} lg={6} xl={6} key={s.id}>
        <Grades subject={s} student={student_id}/> 
      </Grid>)}
    </Grid>
  )
}

export default StudentReports
